import { render, staticRenderFns } from "./transferinfrm.vue?vue&type=template&id=02d13df2"
import script from "./transferinfrm.vue?vue&type=script&lang=js"
export * from "./transferinfrm.vue?vue&type=script&lang=js"
import style0 from "./transferinfrm.vue?vue&type=style&index=0&id=02d13df2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports